<template>
  <div>
    <title-bar title="APP版本管理">
      <el-button type="primary" icon="fa fa-upload" @click="upload">上传</el-button>
    </title-bar>
    <div class="page-body">
      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="versionName" label="版本号" min-width="120"></el-table-column>
        <el-table-column prop="osName" label="适配类型" min-width="120"></el-table-column>
        <el-table-column prop="publishTime" label="发布时间" align="center" min-width="120"></el-table-column>
        <el-table-column prop="qrcode" label="扫码下载" align="center" width="50">
          <template slot-scope="{ row, $index }">
            <el-popover trigger="click" @show="buildQrCode(row)">
              <div style="width:240px;text-align: center;word-wrap: break-word">{{row.examTitle}}</div>
              <el-image :src="qrUrl"></el-image>
              <div style="width:240px;text-align: center;word-wrap: break-word">
                {{ appDownloadUrl }}
              </div>
              <el-link icon="fa fa-qrcode" :underline="false" slot="reference"></el-link>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作" width="100" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" icon="fa fa-download" title="下载" @click="download(row)" style="font-size: 16px"></el-button>
            <el-button type="text" icon="fa fa-times-circle color-error" title="删除" @click="del(row)" style="font-size: 16px"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>

    <app-upload v-if="editing" :visible.sync="editing" @save="editing=false;query()" @close="editing=false"></app-upload>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import AppUpload from "@/components/app-version/AppUpload";
import QRCode from "qrcode";
export default {
  components: {AppUpload, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      queryForm: {
        page: 1,
        limit: 10
      },
      total: 0,
      records: [],
      //app下载地址
      appDownloadUrl: null,
      //二维码图片地址
      qrUrl: null,
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/app-version/v2/list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    download(row) {
      window.open(this.globalConfig.apiRoot+"/app-version/download?osName=android&versionName="+row.versionName);
    },
    del(row) {
      this.$confirm("确定要删除该APP版本吗？","系统提示").then(()=>{
        this.postForm("/app-version/delete",{versionName: row.versionName}).then(()=>{
          this.loadData();
        });
      })
    },
    upload() {
      this.editing = true;
    },
    //生成二维码图片地址
    buildQrCode(row) {
      this.appDownloadUrl = this.globalConfig.apiRoot+"/app-version/download?osName=android&versionName="+row.versionName;
      QRCode.toDataURL(this.appDownloadUrl,{
        errorCorrectionLevel: 'L',
        width: 240,
        margin: 2
      }, (err,url) => {
        if(err) {
          this.$message.error("生成二维码失败");
        }else{
          this.qrUrl = url;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>